import { render, staticRenderFns } from "./Cangetcoupondia.vue?vue&type=template&id=a0456c9a&scoped=true&"
import script from "./Cangetcoupondia.vue?vue&type=script&lang=js&"
export * from "./Cangetcoupondia.vue?vue&type=script&lang=js&"
import style0 from "./Cangetcoupondia.vue?vue&type=style&index=0&id=a0456c9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0456c9a",
  null
  
)

export default component.exports